import React from "react";
import styled, { css } from "styled-components";
import PropTypes from "prop-types";

import { statesConst } from "_constants";
import breakpoints from "_constants/breakpoints";

import { getProductMailFiles, phoneFormatter } from "_helpers";

import Documents from "components/OrderDetail/Documents";

const Container = styled.div`
  min-width: 100%;
  max-width: 100%;
  padding: 25px 32px 56px;
  margin-bottom: 33px;
  background: #ffffff;
  box-shadow: 0px 3px 25px rgba(168, 168, 168, 0.3);

  @media (max-width: ${breakpoints.mobileL}) {
    padding: 24px 16px;
  }
`;

const Row = styled.div`
  display: flex;
  flex-direction: column;
  border-top: 1px solid #ecedf1;

  &:last-child {
    border-bottom: 1px solid #ecedf1;
  }
`;
const DataRow = styled.div`
  display: flex;
  min-width: 100%;
  padding: 16px 0;

  &:nth-child(2n + 1) {
    background-color: #fafaff;
  }

  @media (max-width: ${breakpoints.tablet}) {
    flex-direction: column;
  }
`;
const Label = styled.div`
  min-width: 50%;
  width: 50%;
  padding-right: 20px;
  font-weight: normal;
  font-size: 12px;
  /* text-transform: uppercase; */
  color: #7b848d;
  word-break: break-all;

  @media (max-width: ${breakpoints.tablet}) {
    min-width: 100%;
    width: 100%;
    padding-right: 0;
  }
`;
const Data = styled(Label)`
  font-weight: bold;
  text-transform: none;
  word-break: break-all;

  @media (max-width: ${breakpoints.mobileL}) {
    align-items: center;
  }
`;
const CenterdText = styled.div`
  width: 100%;
  padding: 24px;
  color: #7b848d;
  text-align: center;
  font-weight: bold;
`;
const Title = styled.div`
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  text-align: center;
  color: #03589c;
  margin: 24px 0;

  ${({ theme: { mobile } }) =>
    mobile &&
    css`
      font-size: 22px;
      border-bottom: none;

      @media (max-width: ${breakpoints.mobileM}) {
        font-size: 18px;
        padding: 0;
      }
    `}
`;

const Divider = styled.div`
  margin: 32px;
`;

const TrademarkPrivacyPackageSubscription = ({ productDetails }) => {
  const virtualAddress = productDetails.virtualAddress;
  const files = getProductMailFiles(productDetails);

  return (
    <Container>
      <Row>
        <DataRow>
          <Label>Private Phone Number</Label>
          <Data>{phoneFormatter(productDetails?.phoneNumber) || "—"}</Data>
        </DataRow>
        <DataRow>
          <Label>Private Email Address</Label>
          <Data>{productDetails?.email || "—"}</Data>
        </DataRow>
        <DataRow>
          <Label>Virtual Address</Label>
          <Data>{`${virtualAddress?.address1 || "—"}, ${virtualAddress?.city || "—"}, ${
            statesConst[virtualAddress?.state] || "—"
          }, ${virtualAddress?.zip || "—"}`}</Data>
        </DataRow>
      </Row>
      <Row>
        <CenterdText>
          Any important phone or email correspondence will be conveyed to you by our customer service team.
        </CenterdText>
      </Row>
      <Divider />
      <Title>Mail Received</Title>
      <Documents
        orderId={productDetails?.orderId}
        product={productDetails}
        productId={productDetails?.id}
        files={files}
      />
    </Container>
  );
};

export default TrademarkPrivacyPackageSubscription;

TrademarkPrivacyPackageSubscription.propTypes = {
  productDetails: PropTypes.object,
};
